import axios from 'axios';

const LOGINAPI = '/api/auth-oidc';
const API = '/api/auth';

const authService = {
  // Redirect user to OIDC provider
  async login() {
    const res = await axios.get(`${LOGINAPI}/login`, {
      withCredentials: true
    });

    return res.data.authorizationUrl;
  },

  // Finish login after redirect
  async sendCallbackParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(queryParams.entries());

    await axios.get(`${API}/callback`, {
      params,
      withCredentials: true
    });

    // No tokens returned — they are stored in session
    return true;
  },

  // Check session and get user info
  async getSession() {
    const res = await axios.get(`${API}/session`, {
      withCredentials: true
    });

    return res.data;
  },

  // Logout
  async logout() {
    const res = await axios.get('/api/auth-oidc/end-session', {
      withCredentials: true
    });

    if (!res.data?.endSessionUrl) {
      throw new Error('End session URL not returned from backend');
    }

    return res.data.endSessionUrl;
  }
};

export default authService;
